export const realEstateRoutePaths = {
  realEstate: {
    path: 'real-estate',
    fullPath: '/real-estate',
  },
  trades: {
    path: 'real-estate/trades',
    fullPath: '/real-estate/trades',
  },
  complex: {
    path: 'real-estate/complex/:name',
    fullPath: (name: string, sggCd: string, propertyType?: string) => {
      const params = new URLSearchParams({ sggCd });
      if (propertyType) params.set('propertyType', propertyType);
      return `/real-estate/complex/${encodeURIComponent(name)}?${params.toString()}`;
    },
  },
  loan: {
    path: 'real-estate/loan',
    fullPath: '/real-estate/loan',
  },
  buildings: {
    path: 'real-estate/buildings',
    fullPath: '/real-estate/buildings',
  },
  subscriptions: {
    path: 'real-estate/subscriptions',
    fullPath: '/real-estate/subscriptions',
  },
  watchlist: {
    path: 'real-estate/watchlist',
    fullPath: '/real-estate/watchlist',
  },
  score: {
    path: 'real-estate/score',
    fullPath: '/real-estate/score',
  },
  affordability: {
    path: 'real-estate/affordability',
    fullPath: '/real-estate/affordability',
  },
  map: {
    path: 'real-estate/map',
    fullPath: '/real-estate/map',
  },
};
